var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"disabled":_vm.disabled,"variant":"danger"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.$t('Delete'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }